import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/index.scss'
// import '@/assets/js/rem.js'
import '@/assets/iconfont/iconfont.css'
import iView from 'iview';
import 'iview/dist/styles/iview.css';// 使用 CSS
import $ from 'jquery'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import vuescroll from 'vuescroll';
//设置全局配置
Vue.use(vuescroll, {
    ops: {
        //滚动条颜色
        bar: {
            size: '4px',
            background: '#DDDEE0',
        }
    },
    name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
});
window.$ = $

let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
if (flag) {
    require('@/assets/js/rem.js')
}

import vueWechatTitle from "vue-wechat-title";

Vue.use(vueWechatTitle);

Vue.use(iView)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

